<template>
  <div id="app" class="flex h-100 flex-wrap pagebg" style="overflow: hidden">
    <!-- 加载动画 -->
    <div class="loads" v-show="isload">
      <dv-loading style="width: 250px; height: 250px">Loading...</dv-loading>
    </div>
    <div class="prductCategory">
      <el-dropdown @command="selectProduct" trigger="click">
        <span style="color: white" class="el-dropdown-link">
          审核表分类：{{ product["uuid"] ? product["title"] : "所有分类"
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="''">所有分类</el-dropdown-item>
          <el-dropdown-item :command="item" v-for="(item, i) in productList" :key="i">{{ item.title }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="time">
      {{ now }} {{ week }}<br />
      更新时间：{{ updateTimeText }}
    </div>
    <div @click="signOut" class="power">
      <i style="cursor: pointer" class="el-icon-back"></i>
    </div>
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <dv-decoration-5 :dur="10" style="position: absolute; bottom: 0; right: 0; height: 50%" class="w-100" />

      <div class="font-big font-weight">
        {{ title ? title : "分层审核看板" }}
      </div>
    </header>
    <div class="p w-25 h-30 flex"> 
      <!--6个月计划完成率-->
      <lpa-plan-finish-rate :beans="planList"></lpa-plan-finish-rate>
    </div>
    <div class="p w-25 h-30 flex">
      <!--部门当月计划完成率-->
      <lpa-dept-finish-rate :beans="deptPlanList"></lpa-dept-finish-rate>
    </div>
    <div class="p w-25 h-30 flex">
      <!--6个月问题关闭率-->
      <lpa-issue-close-rate :beans="issueRate"></lpa-issue-close-rate>
    </div>
    <div class="p w-25 h-30 flex">
      <!--部门当月问题关闭率-->
      <lpa-dept-close-rate :beans="deptIssueList"></lpa-dept-close-rate>
    </div>
    <div class="p w-25 h-30 flex">
      <!--部门发现率-->
      <lpa-dept-discovery-rate :beans="deptovery"></lpa-dept-discovery-rate>
    </div>
    <div class="p w-50 h-30 flex">
      <!--岗位当月完成总进度 and 分别进度-->
      <lpa-job-total :tempCategory="productUUID" :beans="jobTotal"></lpa-job-total>
    </div>
    <div class="p w-25 h-30 flex">
      <!--当年部门未完成数量-->
      <lpa-dept-unfinished-total :beans="deptUnfinishedPlan"></lpa-dept-unfinished-total>
    </div>
    <div class="p w-25 h-30 flex">
      <!--6个月符合率-->
      <lpa-conform-rate :beans="conformList"></lpa-conform-rate> 
    </div>
    <div class="p w-50 h-30 flex">
      <!--问题未关闭列表-->
      <lpa-issue-list :beans="issueList"></lpa-issue-list>
    </div>
    <!--产线问题分类-->
    <div class="p w-25 h-30 flex">
      <lpa-production-category :beans="productionList"></lpa-production-category>
    </div>
     <!--本月问题分类统计-->
    <!-- <div class="p w-25 h-30 flex">
      <lpa-question-category :beans="issueCategoryList"></lpa-question-category>
    </div> -->
    <!--责任部门问题分类-->
    <!-- <div class="p w-25 h-30 flex">
      <lpa-job-category :beans="deptIssueCategory"></lpa-job-category>
    </div> -->
  </div>
</template> 

<script>
import API from "@/utils/api";
import router from "../../../router";
import format from "date-fns/format";
export default {
  name: "App",
  data() {
    return {
      websock: null,
      lockReconnect: false,
      reconnectData: null,
      isload: false,
      planList: [], //计划完成率
      deptPlanList: [], //部门当月计划完成率
      issueRate: [], //问题关闭率
      deptIssueList: [], //部门当月问题关闭率
      jobTotal: [], //层别信息
      deptovery: [], //部门发现率,
      conformList: [], //符合率
      deptUnfinishedPlan: [], //部门未完成计划数量
      productionList: [], //产线问题分类
      issueCategoryList: [], //责任部门问题分布
      issueList: [], //未关闭问题列表
      now: null,
      week: null,
      logoSrc: "/assets/img/logo_light.png",
      title: "分层审核",
      productList: [],
      product: {},
      productUUID: null,
      updateTimeText: null,
    };
  },

  mounted() {
    this.webSocket();
    this.loadData();
    this.loadBoardTitle();
    this.loadTemplateCategory();
    //钟表
    setInterval(this.clock, 1000);

    //轮训加载
   // setInterval(this.loadData, 60000);
  },
  created() {
    this.isload = true;
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
  },
  methods: {
    signOut() {
      router.back();
    },
    loadProductLine() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadProductLine()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadTemplateCategory() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        API.loadTemplateCategory()
          .then((res) => {
            if (res.success === true) {
              this.productList = res["list"];
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");

      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }

      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });

      var params = { query: { name: "layeraudit" } };
      API.loadBoardTitle(params).then((re) => {
        if (re.success && re["list"].length > 0) {
          this.title = re["list"][0]["boardName"];
        }
      });
    },
    selectProduct(item) {
      this.product = item || {};
      this.productUUID = item ? item.uuid : null;
      this.isload = true;
      this.loadData();
    },
    loadData() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        this.isload = false;
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);

        var params = { templateCategoryUUID: this.product["uuid"] };

        API.lpaData(params)
          .then((res) => {
            this.isload = false;
            if (res.success === true) {
              this.planList = res["audits"];
              this.deptPlanList = res["deptRate"];
              this.issueRate = res["issueClose"];
              this.deptIssueList = res["deptIssueClose"];
              this.jobTotal = res["jobTotalAudit"];
              this.deptovery = res["deptDiscovery"];
              this.conformList = res["conformRate"];
              this.deptUnfinishedPlan = res["deptUnfinishedPlan"];
              this.deptIssueCategory = res["deptIssueCategory"];
              this.productionList = res["production"];
              this.issueCategoryList=res['lpaQuestionCategory'];
              this.issueList = res["issueList"];
              this.jobList = res["jobs"];
              var now = new Date();
              this.updateTimeText = format(now, "MM-dd HH:mm:ss");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      if (http) {
        http += "/websocket/layeraudit/monitoring";
      } else {
        http = "https://demo.biqs.cn/websocket/layeraudit/monitoring";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;
    },
    //连接成功
    websocketonopen() {
      console.log("分层审核 socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("分层审核 socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log("分层审核 socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      console.log("socket 数据刷新");
      //刷新
      this.loadData();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    clock() {
      //全局变量d，创建Date对象
      var d = new Date();
      //格式：2018-2-5  19:19:33
      this.now = format(d, "yyyy-MM-dd HH:mm:ss");
      var week = new Array(
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      )[d.getDay()];
      this.week = week;
    },
  },
};
</script>

<style>
.prductCategory {
  color: white;
  position: absolute;
  right: 25%;
  top: 10px;
  z-index: 999999;
}

.pagebg {
  background: url("../../../assets/img/bg2.png");
}

.p {
  padding: 0rem 0.2rem;
}

.loads {
  background: #06164a;
  z-index: 999;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0%;
  top: 0%;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}

header {
  background: url("../../../assets/img/head_bg.png");
  background-size: 100% 100%;
  position: relative;
  height: 50px;
}

/* 媒体查询  */
@media screen and (max-width: 1024px) {
  html {
    font-size: 42px !important;
  }
}

@media screen and (min-width: 1920px) {
  html {
    font-size: 80px !important;
  }
}

/* 主题色 */
.color-blue {
  color: #1fe9e8;
}

.color-gray {
  color: #cdeaf6;
}

.logoImg {
  position: absolute;
  left: 80px;
  top: 0px;
  font-size: 22px;
  z-index: 999;
}
</style>
<style scoped src='./board.css'></style>


// WEBPACK FOOTER //
// src/pages/layeraudit/board/board.vue